module.exports = __webpack_public_path__ + "static/media/open.00b1d935.svg";